'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from '@skrym/shared/ui/navigation-menu';

import { pagesMetadata } from '@/.velite';

interface HeaderNavigationProps extends React.ComponentProps<typeof NavigationMenu> {
  showApiReference: boolean;
}

/**
 * These are the navigation items for the header.
 *
 * @see SidebarNavigation for the sidebar navigation items.
 */
export function HeaderNavigation(props: HeaderNavigationProps) {
  const { showApiReference, ...rest } = props;
  const pathname = usePathname();

  const isDocs = pagesMetadata.some((p) => p.pathname === pathname);

  return (
    <NavigationMenu {...rest}>
      <NavigationMenuList>
        <NavigationMenuItem>
          <Link href="/" legacyBehavior passHref>
            <NavigationMenuLink active={isDocs} className={navigationMenuTriggerStyle()}>
              Docs
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <Link href="/changelog" legacyBehavior passHref>
            <NavigationMenuLink
              active={pathname.startsWith('/changelog')}
              className={navigationMenuTriggerStyle()}
            >
              Changelog
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>

        {showApiReference && (
          <NavigationMenuItem>
            <Link href="/api-reference" legacyBehavior passHref>
              <NavigationMenuLink
                active={pathname.startsWith('/api-reference')}
                className={navigationMenuTriggerStyle()}
              >
                API Reference
              </NavigationMenuLink>
            </Link>
          </NavigationMenuItem>
        )}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
